<template>
    <div>
        <hr>
        <div class="card-body">
            <p class="text-center aboutscroll">
                <i class="fas fa-hourglass-half"></i>&nbsp;Waiting for counterparty to accept terms.
            </p>
            <p class="text-center aboutscroll">
                You can discuss terms with the seller in Negotations area meanwhile.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Open",
        props: ['trade_status']
    }
</script>

<style scoped>

</style>
